<template>
    <div class="v-icon mr-2 ">
        <v-btn
            @click="toggleAddDialog(personId)"
            class="info"
        >
            Add Phone Number
        </v-btn>
        <v-dialog
            :value="addPersonPhoneNumberDialog"
            max-width="700px"
            persistent
        >
            <v-card v-if="addPersonPhoneNumberDialog">
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Person Phone Number</span>
                    <v-spacer />
                    <v-btn
                        @click.stop="closeNewItem()"
                        fab
                        rounded
                        small
                        text
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container
                        grid-list-md
                        pt-0
                    >
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addContactNumberErrors"
                                    @blur="$v.addContactNumber.$touch()"
                                    @input="$v.addContactNumber.$touch()"
                                    label="Contact Number"
                                    type="text"
                                    v-model="addContactNumber"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="addTypeErrors"
                                    :items="phoneNumberTypeList"
                                    @blur="$v.addType.$touch()"
                                    @input="$v.addType.$touch()"
                                    item-text="name"
                                    item-value="type"
                                    label="Type"
                                    v-model="addType"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="addCategoryErrors"
                                    :items="phoneNumberCategoryList"
                                    @blur="$v.addType.$touch()"
                                    @input="$v.addType.$touch()"
                                    item-text="name"
                                    item-value="category"
                                    label="Category"
                                    v-model="addCategory"
                                />
                            </v-flex>

                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    v-if="hasPhoneNumberInContactList.showInContactList"
                                    :items="[{Id: false, name: 'No'}]"
                                    @blur="$v.addShowInContactList.$touch()"
                                    @input="$v.addShowInContactList.$touch()"
                                    item-text="name"
                                    item-value="Id"
                                    label="Show In Contact List"
                                    :value="addShowInContactList = false"
                                />
                                <v-select
                                    v-else
                                    :error-messages="addShowInContactListErrors"
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.addShowInContactList.$touch()"
                                    @input="$v.addShowInContactList.$touch()"
                                    item-text="name"
                                    item-value="Id"
                                    label="Show In Contact List"
                                    v-model="addShowInContactList"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { SAVE_NEW_PERSON_PHONE_NUMBER } from "@/store/person_phone_number/actions.js";
import { RESET_DEFAULT_NEW_PERSON_PHONE_NUMBER, TOGGLE_NEW_PERSON_PHONE_NUMBER_DIALOG, UPDATE_ADD_PERSON_PHONE_NUMBER_FIELD } from "@/store/person_phone_number/mutations.js";
import { helpers, required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    // eslint-disable-next-line no-useless-escape
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "AddPersonPhoneNumberDialog",

        validations: {
            addContactNumber: {phone, required},
            addType: {required},
            addCategory: {required},
            addShowInContactList: {required}
        },

        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        computed: {
            ...mapGetters(
            [
                "phoneNumberCategoryList",
                "phoneNumberTypeList",
                "person",
                "hasPhoneNumberInContactList",
                "addPersonPhoneNumberDialog",
            ],
            ),
            addContactNumber: {
                get() {
                    return this.$store.state.person_phone_number.addPersonPhoneNumber.contactNumber;
                },
                set(value) {
                    this.updateNewValue('contactNumber', value);
                }
            },

            addContactNumberErrors() {
                const errors = [];
                if (!this.$v.addContactNumber.$dirty) {
                    return errors;
                }
                if (!this.$v.addContactNumber.required) {
                    errors.push('Required.');
                }
                if (!this.$v.addContactNumber.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            addType: {
                get() {
                    return this.$store.state.person_phone_number.addPersonPhoneNumber.type;
                },
                set(value) {
                    this.updateNewValue('type', value);
                }
            },

            addTypeErrors() {
                const errors = [];
                if (!this.$v.addType.$dirty) return errors;
                !this.$v.addType.required && errors.push('required.');
                return errors
            },
            addCategory: {
                get() {
                    return this.$store.state.person_phone_number.addPersonPhoneNumber.category;
                },
                set(value) {
                    this.updateNewValue('category', value);
                }
            },
            addCategoryErrors() {
                const errors = [];
                if (!this.$v.addCategory.$dirty) return errors;
                !this.$v.addCategory.required && errors.push('required.');
                return errors
            },
            addShowInContactList: {
                get() {
                    return this.$store.state.person_phone_number.addPersonPhoneNumber.showInContactList;
                },
                set(value) {
                    this.updateNewValue('showInContactList', value);
                }
            },
            addShowInContactListErrors() {
                const errors = [];
                if (!this.$v.addShowInContactList.$dirty) return errors;
                !this.$v.addShowInContactList.required && errors.push('required.');
                return errors
            },
        },

        mounted() {
            if (this.personId !== undefined) {
                this.resetNewItemToDefault(this.personId);
                this.updateNewValue('personId', this.personId);
            }
        },

        methods: {
            ...mapActions({
                saveNewTableItemRecord: SAVE_NEW_PERSON_PHONE_NUMBER,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_PHONE_NUMBER_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_PERSON_PHONE_NUMBER_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_PHONE_NUMBER,
            }),
        }
    }
</script>

<style scoped>

</style>
